<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>违规撤销管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">违规撤销列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="账号名称">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入账号名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="jobTitle" label="所属任务" align="center">
          </el-table-column>
          <el-table-column prop="violateId" label="违约编号" align="center">
          </el-table-column>
          <!-- <el-table-column label="投诉编号" align="center">
            <template slot-scope="scope">{{
              scope.row.jobComplainId
            }}</template>
          </el-table-column> -->
          <el-table-column label="扣款方" align="center">
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <el-table-column label="违约支付状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.violatePayStatus == 0" class="yellowColor"
                >待支付</span
              >
              <span v-if="scope.row.violatePayStatus == 1" class="greenColor"
                >已支付</span
              >
            </template>
          </el-table-column>
          <el-table-column label="违约扣款" align="center">
            <template slot-scope="scope"
              >￥{{ scope.row.violateAmount | moneyFormat }}
            </template>
          </el-table-column>
          <el-table-column label="取消金额" align="center">
            <template slot-scope="scope"
              >￥{{ scope.row.backAmount | moneyFormat }}
            </template>
          </el-table-column>
          <el-table-column label="操作人" align="center">
            <template slot-scope="scope"
              >{{ scope.row.modifierName }}
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">待处理</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已完成</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div
                class="disAround"
                v-if="scope.row.status == 0 || scope.row.actualPayAmount > 0"
              >
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  确认批复
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加违规撤销"
      :visible.sync="dialogFormVisible"
      width="600px"
    >
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="客户" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入客户姓名或者手机号"
            ><el-button slot="append" type="primary" @click="select()"
              >查询任务</el-button
            ></el-input
          >
        </el-form-item>
        <el-form-item label="任务列表" prop="task">
          <el-select
            v-model="ruleForm1.task"
            placeholder="请选择"
            @change="selectList"
          >
            <el-option
              v-for="item in taskList"
              :key="item.jobNo"
              :label="item.title"
              :value="item.jobNo"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="违约编号" prop="num">
          <el-select
            v-model="ruleForm1.num"
            placeholder="请选择"
            @change="selectNum"
          >
            <el-option
              v-for="item in numList"
              :key="item.violateLogNo"
              :label="item.violateLogNo"
              :value="item.violateLogNo"
            >
            </el-option>
          </el-select>
          <!-- <el-button type="primary" style="margin-left:10px">查看</el-button> -->
        </el-form-item>
        <el-form-item label="支付状态" prop="status">
          <el-input
            disabled
            v-model="ruleForm1.status"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="扣款方" prop="customPrice">
          <el-input
            v-model="ruleForm1.customPrice"
            disabled
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="扣款金额" prop="money1">
          <el-input
            v-model="ruleForm1.money1"
            disabled
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="撤销金额" prop="money">
          <el-input
            v-model="ruleForm1.money"
            placeholder="请输入撤销金额"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.customerData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      ruleForm1: {
        name: "",
        num: "",
        task: "",
        status: "",
        customPrice: "",
        money1: "",
        money: "",
      },
      rules: {
        num: [{ required: true, message: "必选项", trigger: "change" }],
        task: [{ required: true, message: "必选项", trigger: "change" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        money: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      dialogFormVisible: false,
      taskList: [],
      numList: [],
      detail: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            backAmount: this.ruleForm1.money,
            jobNo: this.ruleForm1.task,
            memberId: this.detail.memberId,
            memberType: this.detail.memberType,
            violateLogNo: this.ruleForm1.num,
          };
          this.$axios
            .post(`/admapi/violateback/add`, param)
            .then(({ data }) => {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally(() => {
              this.dialogFormVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    add() {
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      this.$axios
        .post(`/admapi/violateback/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    selectList(val) {
      let param = {
        jobNo: val,
      };
      this.$axios
        .post(`/admapi/violate/violatelist`, param)
        .then(({ data }) => {
          this.numList = data.items;
        })
        .catch()
        .finally();
    },
    selectNum(val) {
      let id = "";
      for (var i = 0; i < this.numList.length; i++) {
        if (val == this.numList[i].violateLogNo) {
          id = this.numList[i].id;
        }
      }
      this.$axios
        .post(`/admapi/violate/get/${id}`)
        .then(({ data }) => {
          this.detail = data;
          this.ruleForm1.status = data.status == 0 ? "待支付" : "已支付";
          this.ruleForm1.money1 = data.violateAmount - data.cancelAmount;
          let val = "";
          if (data.memberType == 3) {
            // val = data;
            this.ruleForm1.customPrice = val;
          }
          if (data.memberType == 4) {
            let phone = this.ruleForm1.name.replace(
              /(\d{3})\d{4}(\d{4})/,
              "$1****$2"
            );
            val = phone;
            this.ruleForm1.customPrice = val;
          }
        })
        .catch()
        .finally();
    },
    select() {
      let param = {
        phone: this.ruleForm1.name,
      };
      this.$axios
        .post(`/admapi/custom/joblistbyphone`, param)
        .then(({ data }) => {
          this.taskList = data.items;
        })
        .catch()
        .finally();
    },
    handleEdit(val) {
      let param = {
        id: val.id,
      };
      this.$axios
        .post(`/admapi/violateback/confirm`, param)
        .then(({ data }) => {
          this.$message({
            message: "复批成功",
            type: "success",
          });
          this.getList();
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped></style>
